import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=30186944&"
import script from "./SelectProduct.vue?vue&type=script&lang=ts&"
export * from "./SelectProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30186944')) {
      api.createRecord('30186944', component.options)
    } else {
      api.reload('30186944', component.options)
    }
    module.hot.accept("./SelectProduct.vue?vue&type=template&id=30186944&", function () {
      api.rerender('30186944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectProduct.vue"
export default component.exports